import type { Account, Snapshot } from '@repo/api-gw-sdk';
import { Provider } from '@repo/api-gw-sdk';

import { MongoAtlasConfiguration } from './steps/mongoAtlasConfiguration';
import { SelectTargetAccountStep } from './steps/selectTargetAccount';

import type { Step } from '../wizard/Step';
import { Wizard } from '../wizard/Wizard';

export interface restoreMongoAtlasState {
  resourceId: string;
  snapshot: Snapshot;
  resourceName?: string;
  supportedCloudProviders: Provider[];
  restoreAccount?: Account;
  projectId?: string;
  tags: Record<string, string>;
  initialTags: Record<string, string>;
  keepOriginalTags: boolean;
}

const restoreMongoAtlasFlow: Step<restoreMongoAtlasState> = {
  id: 'select_target_account_step',
  Component: SelectTargetAccountStep,
  next: [
    {
      id: 'mongo_atlas_configuration',
      Component: MongoAtlasConfiguration,
    },
  ],
};

export const RestoreMongoAtlasWizard = ({
  snapshot,
  onClose,
  onBack,
}: {
  snapshot: Snapshot;
  onClose: () => void;
  onBack: () => void;
}) => {
  return (
    <Wizard<restoreMongoAtlasState>
      onAbort={(origin) => (origin === 'back' ? onBack() : onClose())}
      onFinish={async () => true}
      flow={[restoreMongoAtlasFlow]}
      initialState={{
        snapshot,
        resourceId: snapshot.resourceId,
        supportedCloudProviders: [Provider.MongoAtlas],
        keepOriginalTags: true,
        initialTags: snapshot.resource?.tags || {},
        tags: snapshot.resource?.tags || {},
      }}
      title={`Restore Mongo Atlas Cluster`}
      stepperLabels={['Restore Account', 'Configuration']}
    />
  );
};
